import { Box, Typography } from '@mui/material';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { latestSampleSetInterpretiveReportQueryOptions } from '../../../../../../services/queries';

export const Route = createFileRoute(
  '/_authenticated/_navbar/experiments/$sampleSetId/interpretations/'
)({
  loader: async ({ context, params }) => {
    const latestReport = await context.queryClient.fetchQuery(
      latestSampleSetInterpretiveReportQueryOptions(
        params.sampleSetId,
        context.auth.hasPermission
      )
    );

    if (latestReport) {
      throw redirect({
        to: '/experiments/$sampleSetId/interpretations/$interpretationId',
        params: {
          sampleSetId: params.sampleSetId,
          interpretationId: latestReport.id,
        },
        search: true,
        replace: true,
      });
    }
  },
  // Should only occur if the user manually visits the path with no interpretations
  component: NoReportsRoute,
});

function NoReportsRoute() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 200,
      }}
    >
      <Typography variant="body1" sx={{ color: 'text.secondary' }}>
        No interpretations for this sample set yet.
      </Typography>
    </Box>
  );
}
